(function () {
  // mobile menu
  var t = document.querySelector('[data-menu-toggle]');
  var m = document.querySelector('[data-mobile-menu]');
  if (t && m) {
    t.addEventListener('click', function () {
      var open = m.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  // quantity steppers (product page)
  document.querySelectorAll('.pdp-qty').forEach(function (q) {
    var input = q.querySelector('input');
    var minus = q.querySelector('[data-qty-minus]');
    var plus = q.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value) || 1) + 1; });
  });
  // scroll reveal
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 }) : null;
  if (io) document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  else document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
})();
